import { cn } from '@tempo-io/sui-class-utils';

export const SasiToggleOffIcon = ({ className }: { className?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('inline-block', className)}
  >
    <title>Sasi Toggle Off</title>
    <g id="SasiToggleOff">
      <rect id="Rectangle 7" x="3" y="6" width="14" height="5" fill="#2B343C" />
      <rect id="Rectangle 8" x="7.5" y="13.5" width="13" height="4" stroke="#2B343C" fill="none" />
    </g>
  </svg>
);
